<span
  class="ui-avatar"
  data-testid="ui-avatar"
  [class.ui-avatar-janek]="tone() === 'janek'"
  [class.ui-avatar-zosia]="tone() === 'zosia'"
  [class.ui-avatar-pawel]="tone() === 'pawel'"
  [class.ui-avatar-dom]="tone() === 'dom'"
  [class.ui-avatar-neutral]="tone() === 'neutral'"
  [attr.aria-label]="label()"
  [style.--ui-avatar-size.px]="size()"
>
  {{ initials() }}
</span>
